module.exports = __webpack_public_path__ + "img/ybk.db6d0ce6.png";